import { Label, Button } from 'semantic-ui-react';
import React from 'react';

const StatusLabels = (props) => {
    return (
        <Label.Group style={{ display: "inline-block"}}>
            {props.labels.map(label => {
                return (
                <Label as={Button} color={label.color} disabled={props.disabled} basic={label.disabled} className="clickable" onClick={() => props.onClick(label.key) } style={{ border: "1px solid"}}>
                    {label.text}
                    <Label.Detail>{label.quantity || 0}</Label.Detail>
                </Label>
                )
            })}
        </Label.Group>
    );
}

export default StatusLabels;